/* ml-bundle.js — Maison Loria "Bundle & Save" widget.
   Plain-div + data-attribute + event-delegation design so it survives the
   theme's sticky product-info DOM reconstruction (which strips inline scripts
   and custom elements). Loaded via <script src> from snippets/ml-bundle-save.liquid.
   The picker opens as a body-level modal (so a transformed ancestor can't clip it);
   both slots are editable; each card has its own "Choose" button. */
(function () {
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function money(fmt, cents){
    var amt = (cents/100).toFixed(2), parts = amt.split('.');
    var intC = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/g, intC + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, intC)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }
  function products(root){ try { return JSON.parse(root.dataset.products || '[]'); } catch (e) { return []; } }
  function state(root){
    if (!root._ml) root._ml = {
      editing: 2,
      item1: {
        id: parseInt(root.dataset.v1Id, 10),
        price: parseInt(root.dataset.v1Price, 10),
        title: root.dataset.v1Title || '',
        image: root.dataset.v1Image || '',
        isCurrent: true
      },
      item2: null
    };
    return root._ml;
  }

  /* The picker is relocated to <body> on first open; keep a reliable handle to it
     and a way to find the owning .ml-bundle root from elements inside the modal. */
  function ensurePickerInBody(root){
    var pk = root.querySelector('[data-ml-picker]');
    if (pk) { pk._root = root; root._pk = pk; document.body.appendChild(pk); }
  }
  function picker(root){ return root._pk || root.querySelector('[data-ml-picker]'); }
  function rootOf(el){
    var b = el.closest && el.closest('.ml-bundle');
    if (b) return b;
    var pk = el.closest && el.closest('.ml-bundle__picker');
    return (pk && pk._root) ? pk._root : null;
  }

  /* --- color → image resolution -------------------------------------------------
     Priority: 1) the variant's own image (variant.image),
               2) a product image whose alt contains "#color_<slug>" (theme convention),
               3) the product's featured image as a fallback. */
  function slugify(s){ return String(s == null ? '' : s).toLowerCase().trim().replace(/\s+/g,'-'); }
  function imgForVariant(p, v){
    if (v && v.vimage) return v.vimage;
    if (p && p.media && p.media.length && v && v.options){
      for (var oi = 0; oi < v.options.length; oi++){
        var slug = slugify(v.options[oi]);
        if (!slug) continue;
        for (var mi = 0; mi < p.media.length; mi++){
          var alt = (p.media[mi].alt || '').toLowerCase();
          if (alt.indexOf('#color_' + slug) !== -1) return p.media[mi].src;
        }
      }
    }
    return (p && p.image) || '';
  }
  function variantById(p, id){
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++){ if (p.variants[i].id === id) return p.variants[i]; }
    return null;
  }
  function productIndexForVariant(root, id){
    var prods = products(root);
    for (var i = 0; i < prods.length; i++){ if (variantById(prods[i], id)) return i; }
    return -1;
  }

  function buildGrid(root){
    var pk = picker(root); if (!pk) return;
    var grid = pk.querySelector('[data-ml-grid]');
    if (!grid || grid.dataset.built) return;
    var fmt = root.dataset.moneyFormat, html = '';
    products(root).forEach(function (p, i) {
      var fa = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      if (!fa) return;
      var faImg = imgForVariant(p, fa);
      html += '<button type="button" class="ml-card" data-i="'+i+'" data-vid="'+fa.id+'" data-price="'+fa.price+'" data-img="'+esc(faImg)+'">'
        + (faImg ? '<img class="ml-card__img" loading="lazy" src="'+esc(faImg)+'" alt="">' : '<span class="ml-card__img"></span>')
        + '<span class="ml-card__title">'+esc(p.title)+'</span>'
        + '<span class="ml-card__price">'+money(fmt, fa.price)+'</span>';
      html += '<span class="ml-card__variants">';
      p.variants.forEach(function (v) {
        var vimg = imgForVariant(p, v);
        html += '<span class="ml-card__variant'+(v.id===fa.id?' is-active':'')+(v.available?'':' is-disabled')+'" data-vid="'+v.id+'" data-price="'+v.price+'" title="'+esc(v.title)+'">'
          + (vimg ? '<img src="'+esc(vimg)+'" alt="'+esc(v.title)+'" loading="lazy">' : '<span class="ml-card__variant-empty">'+esc(v.title)+'</span>')
          + '</span>';
      });
      html += '</span>';
      html += '<span class="ml-card__choose" data-ml-confirm>Choose</span>';
      html += '</button>';
    });
    grid.innerHTML = html || '<p style="grid-column:1/-1;color:#8a8a8a;margin:0;">No products available.</p>';
    grid.dataset.built = '1';
  }

  /* Highlight a card as the pending (not yet confirmed) choice. */
  function selectCard(root, card){
    var pk = picker(root); if (!pk) return;
    pk.querySelectorAll('.ml-card').forEach(function (c) { c.classList.remove('is-selected'); });
    card.classList.add('is-selected');
  }

  /* Apply a variant (color) to a card: active swatch, price text and image. */
  function applyVariantToCard(root, card, vid){
    var p = products(root)[parseInt(card.dataset.i, 10)];
    var variant = variantById(p, vid);
    if (!variant) return;
    card.querySelectorAll('.ml-card__variant').forEach(function (c) { c.classList.remove('is-active'); });
    var chip = card.querySelector('.ml-card__variant[data-vid="'+vid+'"]');
    if (chip) {
      chip.classList.add('is-active');
      var wrap = chip.parentNode;
      if (wrap && wrap.scrollWidth > wrap.clientWidth) {
        wrap.scrollLeft = chip.offsetLeft - (wrap.clientWidth - chip.clientWidth) / 2;
      }
    }
    card.dataset.vid = String(vid);
    card.dataset.price = String(variant.price);
    var priceEl = card.querySelector('.ml-card__price');
    if (priceEl) priceEl.textContent = money(root.dataset.moneyFormat, variant.price);
    var newImg = imgForVariant(p, variant);
    if (newImg) {
      card.dataset.img = newImg;
      var imgEl = card.querySelector('.ml-card__img');
      if (imgEl && imgEl.tagName === 'IMG') imgEl.src = newImg;
    }
  }

  /* When the picker opens for a slot, pre-highlight that slot's current pick. */
  function syncPickerSelection(root){
    var pk = picker(root); if (!pk) return;
    var s = state(root);
    var cur = s.editing === 1 ? s.item1 : s.item2;
    pk.querySelectorAll('.ml-card').forEach(function (c) { c.classList.remove('is-selected'); });
    if (!cur || !cur.id) return;
    var i = productIndexForVariant(root, cur.id);
    if (i === -1) return;
    var card = pk.querySelector('.ml-card[data-i="'+i+'"]');
    if (!card) return;
    applyVariantToCard(root, card, cur.id);
    card.classList.add('is-selected');
  }

  /* Confirm a card into the slot currently being edited, then close. */
  function commitSelection(root, card){
    var s = state(root), pk = picker(root);
    if (!card && pk) card = pk.querySelector('.ml-card.is-selected');
    if (!card) return;
    var p = products(root)[parseInt(card.dataset.i, 10)];
    var variant = variantById(p, parseInt(card.dataset.vid, 10));
    var img = card.dataset.img || imgForVariant(p, variant) || (p && p.image) || '';
    var picked = { id: parseInt(card.dataset.vid, 10), price: parseInt(card.dataset.price, 10), title: p.title, image: img };
    if ((s.editing || 2) === 1) { picked.isCurrent = false; s.item1 = picked; renderItem1(root); }
    else { s.item2 = picked; renderItem2(root); }
    render(root);
    closePicker(root);
  }
  function openPicker(root){
    var pk = picker(root); if (pk) pk.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closePicker(root){
    var pk = picker(root); if (pk) pk.hidden = true;
    document.body.style.overflow = '';
  }

  function render(root){
    var s = state(root), sum = root.querySelector('[data-ml-summary]'), cta = root.querySelector('[data-ml-add]');
    if (!s.item1 || !s.item2) { if (sum) sum.hidden = true; if (cta) cta.disabled = true; return; }
    var disc = parseFloat(root.dataset.discount) || 0, fmt = root.dataset.moneyFormat;
    var sub = s.item1.price + s.item2.price, d = Math.round(sub * disc / 100), tot = sub - d;
    root.querySelector('[data-ml-strike]').textContent = money(fmt, sub);
    root.querySelector('[data-ml-total]').textContent = money(fmt, tot);
    root.querySelector('[data-ml-save]').textContent = 'You save ' + money(fmt, d) + ' (−' + disc + '%)';
    sum.hidden = false; cta.disabled = false;
  }
  function renderItem1(root){
    var slot = root.querySelector('.ml-bundle__item--current'); if (!slot) return;
    var s = state(root), fmt = root.dataset.moneyFormat;
    if (!s.item1) return;
    slot.classList.add('is-filled');
    slot.innerHTML =
      '<div class="ml-bundle__thumb">' + (s.item1.image ? '<img src="'+esc(s.item1.image)+'" alt="" width="120" height="120" loading="lazy">' : '') + '</div>'
      + '<span class="ml-bundle__name">' + esc(s.item1.title) + '</span>'
      + '<span class="ml-bundle__price" data-ml-price1>' + money(fmt, s.item1.price) + '</span>'
      + '<button type="button" class="ml-bundle__change" data-ml-open data-ml-slot="1">Change</button>';
  }
  function renderItem2(root){
    var slot = root.querySelector('.ml-bundle__item--second'); if (!slot) return;
    var s = state(root), fmt = root.dataset.moneyFormat;
    if (!s.item2) return;
    slot.classList.add('is-filled');
    slot.innerHTML =
      '<div class="ml-bundle__thumb">' + (s.item2.image ? '<img src="'+esc(s.item2.image)+'" alt="" width="120" height="120" loading="lazy">' : '') + '</div>'
      + '<span class="ml-bundle__name">' + esc(s.item2.title) + '</span>'
      + '<span class="ml-bundle__price">' + money(fmt, s.item2.price) + '</span>'
      + '<button type="button" class="ml-bundle__change" data-ml-open data-ml-slot="2">Change</button>';
  }
  function renderCart(res){
    var targets = [
      { id:'Cart', sel:'.thb-cart-form', sec:'main-cart' },
      { id:'Cart-Drawer', sel:'.cart-drawer', sec:'cart-drawer' },
      { id:'cart-drawer-toggle', sel:'.thb-item-count', sec:'cart-bubble' }
    ];
    if (res.sections) targets.forEach(function (t) {
      var host = document.getElementById(t.id); if (!host || !res.sections[t.sec]) return;
      var el = host.querySelector(t.sel) || host;
      var parsed = new DOMParser().parseFromString(res.sections[t.sec], 'text/html').querySelector(t.sel);
      if (parsed) el.innerHTML = parsed.innerHTML;
    });
    var drawer = document.getElementById('Cart-Drawer');
    if (typeof OverlayManager !== 'undefined' && drawer) OverlayManager.open(drawer);
    if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart-drawer:open');
    else document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }
  function addBundle(root){
    var s = state(root); if (!s.item1 || !s.item2) return;
    var err = root.querySelector('[data-ml-error]'), cta = root.querySelector('[data-ml-add]');
    err.hidden = true; cta.classList.add('is-loading'); cta.disabled = true;
    fetch(root.dataset.addUrl, {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/javascript', 'X-Requested-With':'XMLHttpRequest' },
      body: JSON.stringify({ items:[{ id:s.item1.id, quantity:1 }, { id:s.item2.id, quantity:1 }], sections:['main-cart','cart-drawer','cart-bubble'], sections_url: window.location.pathname })
    })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      if (res.status) { err.textContent = res.description || res.message || 'Could not add to cart.'; err.hidden = false;
        if (res.status === 422) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); return; }
      renderCart(res);
    })
    .catch(function () { err.textContent = 'Could not add to cart.'; err.hidden = false; })
    .finally(function () { cta.classList.remove('is-loading'); cta.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    var open = t.closest && t.closest('[data-ml-open]');
    if (open) {
      var r = open.closest('.ml-bundle'); if (!r) return;
      var s = state(r);
      s.editing = parseInt(open.dataset.mlSlot, 10) || 2;
      ensurePickerInBody(r);
      buildGrid(r);
      syncPickerSelection(r);
      var pk = picker(r);
      var titleEl = pk && pk.querySelector('[data-ml-picker-title]');
      if (titleEl) titleEl.textContent = (s.editing === 1 ? 'Choose 1st bag' : (r.dataset.secondLabel || 'Choose 2nd bag'));
      openPicker(r);
      return;
    }

    var close = t.closest && t.closest('[data-ml-close]');
    if (close) { var rc = rootOf(close); if (rc) closePicker(rc); return; }

    var chip = t.closest && t.closest('.ml-card__variant');
    if (chip) {
      e.stopPropagation();
      if (chip.classList.contains('is-disabled')) return;
      var card = chip.closest('.ml-card'), root = rootOf(chip); if (!root) return;
      applyVariantToCard(root, card, parseInt(chip.dataset.vid, 10));
      selectCard(root, card);
      return;
    }

    var confirm = t.closest && t.closest('[data-ml-confirm]');
    if (confirm) { e.stopPropagation(); var rr = rootOf(confirm); if (rr) commitSelection(rr, confirm.closest('.ml-card')); return; }

    var card = t.closest && t.closest('.ml-card');
    if (card) { var rs = rootOf(card); if (rs) selectCard(rs, card); return; }

    var add = t.closest && t.closest('[data-ml-add]');
    if (add) { addBundle(add.closest('.ml-bundle')); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;
    var pk = document.querySelector('.ml-bundle__picker:not([hidden])');
    if (pk) { pk.hidden = true; document.body.style.overflow = ''; }
  });

  document.addEventListener('product:variant-change', function (e) {
    if (!(e.detail && e.detail.variant)) return;
    document.querySelectorAll('.ml-bundle').forEach(function (root) {
      var s = state(root);
      if (!s.item1 || !s.item1.isCurrent) return; // slot 1 was changed manually -> don't override
      s.item1.id = e.detail.variant.id; s.item1.price = e.detail.variant.price;
      var p1 = root.querySelector('[data-ml-price1]'); if (p1) p1.textContent = money(root.dataset.moneyFormat, s.item1.price);
      render(root);
    });
  });
})();
